import React from 'react';
import { Button } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { useUpdateRefundMutation } from '../../../../services/RefundService';
import { clearBackupAction as clearBackup } from '../../../../services/RefundService/slice';
import { useNavigate } from 'react-router-dom';

interface SaveChangesButtonProps {
  onError?: (message: string) => void;
}

export const SaveChangesButton: React.FC<SaveChangesButtonProps> = ({ onError }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { currentRefund, isEdited } = useAppSelector(state => state.refund);
  const [updateRefundMutation, { isLoading }] = useUpdateRefundMutation();

  const handleSubmit = async () => {
    if (!currentRefund) return;

    try {
      await updateRefundMutation({ refundView: currentRefund }).unwrap();
      dispatch(clearBackup());
      navigate(-1);
    } catch (err) {
      onError?.('Failed to save changes. Please try again.');
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<SaveIcon />}
      onClick={handleSubmit}
      disabled={isLoading || !isEdited}
      sx={{
        backgroundColor: '#162346',
        '&:hover': {
          backgroundColor: '#1a2a52',
        },
        fontWeight: 600
      }}
    >
      {isLoading ? 'Saving...' : 'Save Changes'}
    </Button>
  );
};